import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import AuthInnerNavbar from "src/components/navbar/authInnerNavbar";
import { LOGOUT } from "../helper/constants";
import { useDispatch } from "react-redux";
import { logout as logoutAction } from "src/store/authSlice";


const ManagerDashboard = lazy(
  () => import("src/screens/innerScreens/manager_dashboard/managerDashboard")
);

const KeySettingScreen = lazy(
  () => import("src/screens/innerScreens/key_setting/keySettingScreen")
);

const MessageSettingScreen = lazy(
  () => import("src/screens/innerScreens/message_setting/messageSettingScreen")
);

const ChangePasswordScreen = lazy(
  () => import("src/screens/innerScreens/profile_change_password/profileChangePasswordScreen")
);

const SmsSettingScreen = lazy(
  () => import("src/screens/innerScreens/sms_setting/smsSettingScreen")
);

const PGSettingScreen = lazy(
  () => import("src/screens/innerScreens/profile_payment_gateway_setting/profilePaymentGatewaySettingScreen")
);

const ProfileScreen = lazy(
  () => import("src/screens/innerScreens/profile/profileScreen")
);

const ProfileGeneralScreen = lazy(
  () => import("src/screens/innerScreens/profile_general/profileGeneralScreen")
);

const ProfileMyProfileScreen = lazy(
  () => import("src/screens/innerScreens/profile_my_profile/profileMyProfileScreen")
);

const ProfileEditMyProfileScreen = lazy(
  () => import("src/screens/innerScreens/profile_my_profile/profileEditMyProfileScreen")
);

const ProfileUpdatesScreen = lazy(
  () => import("src/screens/innerScreens/profile_updates/profileUpdatesScreen")
);

const ProfileSecurityScreen = lazy(
  () => import("src/screens/innerScreens/profile_security/profileSecurityScreen")
);

const InvoiceSettingScreen = lazy(
  () => import("src/screens/innerScreens/invoice_setting/invoiceSettingScreen")
);

const ProfileBillingScreen = lazy(
  () => import("src/screens/innerScreens/profile_billing/profileBillingScreen")
);

const RegisterEmployeeScreen = lazy(
  () => import("src/screens/innerScreens/register_employee/registerEmployeeScreen")
);


const SentSMSReportScreen = lazy(
  () => import("src/screens/innerScreens/report/sent_sms_report/sentSMSReportScreen")
);


const RegisterDepartmentScreen = lazy(
  () => import("src/screens/innerScreens/register_department/registerDepartmentScreen")
);


const RegisterPaymentTypeScreen = lazy(
  () => import("src/screens/innerScreens/register_payment_type/registerPaymentTypeScreen")
);

const RegisterDesignationScreen = lazy(
  () => import("src/screens/innerScreens/register_designation/registerDesignationScreen")
);

const RegisterOfferMasterScreen = lazy(
  () => import("src/screens/innerScreens/register_offer_master/registerOfferMasterScreen")
);

const RegisterPromoCodeScreen = lazy(
  () => import("src/screens/innerScreens/register_promo_code/registerPromoCodeScreen")
);

const AdminDashboardScreen = lazy(
  () => import("src/screens/innerScreens/admin_dashboard/adminDashboardScreen")
);

const RegisterProductsScreen = lazy(
  () => import("src/screens/innerScreens/register_products/registerProductsScreen")
);

const RegisterProductsCategoryScreen = lazy(
  () => import("src/screens/innerScreens/register_products_category/registerProductsCategoryScreen")
);

const RegisterProductsSubCategoryScreen = lazy(
  () => import("src/screens/innerScreens/register_products_sub_category/registerProductsSubCategoryScreen")
);

const RegisterProductDetailsScreen = lazy(
  () => import("src/screens/innerScreens/register_product_Details/registerProductDetailsScreen")
);
const ProductDetailsScreen = lazy(
  () => import("src/screens/outerScreens/productDetails/productDetailsScreen")
);

const RegisterInventoryScreen = lazy(
  () => import("src/screens/innerScreens/register_inventory/registerInventoryScreen")
);

// const WishListScreen = lazy(
//   () => import("src/screens/innerScreens/wishList/wishListScreen")
// );

const MainRoute: React.FC = () => {
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(logoutAction());
    LOGOUT();
  };

  return (
    <AuthInnerNavbar>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/ManagerDashboard" element={<ManagerDashboard />} />
          <Route path="/Logout" element={<LogoutComponent onLogout={handleLogout} />} />
          <Route path="/Profile" element={<ProfileScreen />} />
          <Route path="/KeySetting" element={<KeySettingScreen />} />
          <Route path="/MessageSetting" element={<MessageSettingScreen />} />
          <Route path="/SmsSetting" element={<SmsSettingScreen />} />
          <Route path="/PGSettingScreen" element={<PGSettingScreen />} />
          <Route path="/ProfileGeneral" element={<ProfileGeneralScreen />} />
          <Route path="/ChangePassword" element={<ChangePasswordScreen />} />
          <Route path="/MyProfile" element={<ProfileMyProfileScreen IsUserProfileUploaded={false} />} />
          <Route path="/ProfileUpdates" element={<ProfileUpdatesScreen />} />
          <Route path="/ProfileSecurity" element={<ProfileSecurityScreen />} />
          <Route path="/InvoiceSetting" element={<InvoiceSettingScreen />} />
          <Route path="/ProfileBilling" element={<ProfileBillingScreen />} />
          <Route path="/EditMyProfile" element={<ProfileEditMyProfileScreen />} />
          <Route path="/RegisterEmployee" element={<RegisterEmployeeScreen />} />

          <Route path="/SentSMSReport" element={<SentSMSReportScreen />} />
          <Route path="/RegisterDepartment" element={<RegisterDepartmentScreen />} />


          {/* <Route path="/Quotation" element={<QuotationScreen UserID={0} result={undefined} />} /> */}
          <Route path="/RegisterDesignation" element={<RegisterDesignationScreen />} />
          <Route path="/RegisterOfferMaster" element={<RegisterOfferMasterScreen />} />
          <Route path="/RegisterPromoCode" element={<RegisterPromoCodeScreen />} />
          <Route path="/AdminDashboard" element={<AdminDashboardScreen />} />
          <Route path="/RegisterProducts" element={<RegisterProductsScreen />} />
          <Route path="/RegisterProductsCategory" element={<RegisterProductsCategoryScreen />} />
          <Route path="/RegisterProductsSubCategory" element={<RegisterProductsSubCategoryScreen />} />
          <Route path="/RegisterProductDetails" element={<RegisterProductDetailsScreen />} />
          <Route path="/ProductDetails" element={<ProductDetailsScreen />} />
          <Route path="/RegisterInventory" element={<RegisterInventoryScreen />} />
          {/* <Route path="/WishList" element={<WishListScreen />} /> */}

          
        </Routes>
      </Suspense>
    </AuthInnerNavbar>
  );
};

export default MainRoute;

interface LogoutComponentProps {
  onLogout: () => void;
}

const LogoutComponent: React.FC<LogoutComponentProps> = ({ onLogout }) => {
  React.useEffect(() => {
    onLogout();
  }, [onLogout]);

  return <div>Logging out...</div>;
};
